var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-card card", class: _vm.computedClass },
    [
      _vm.image
        ? [
            !_vm.titleOnImage
              ? _c("img", {
                  staticClass: "card-img-top",
                  attrs: { src: _vm.image, alt: _vm.imageAlt },
                })
              : _vm._e(),
            _vm.titleOnImage
              ? _c("div", { staticClass: "vuestic-card__image-container" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: { src: _vm.image, alt: _vm.imageAlt },
                  }),
                  _vm.overlay
                    ? _c("div", {
                        staticClass: "vuestic-card__image-container__overlay",
                      })
                    : _vm._e(),
                  _c(
                    "h5",
                    { staticClass: "vuestic-card__title card-title" },
                    [_vm._t("title")],
                    2
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _c("div", { staticClass: "card-body" }, [
        _vm.$slots.title && !(_vm.image && _vm.titleOnImage)
          ? _c(
              "h5",
              { staticClass: "vuestic-card__title card-title" },
              [_vm._t("title")],
              2
            )
          : _vm._e(),
        _c("p", { staticClass: "card-text" }, [_vm._t("default")], 2),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }